import { IListOptions, IColorKeys } from './lists.model';

export type multiValuesType = string[] | number[];

export interface IMultiselectOptions extends IListOptions { }


export class MultiselectOptions implements IMultiselectOptions {

    outputKey: string;

    labelKey: string;

    badgeColor: string; //TODO: aggiungere colore

    colorKeys: IColorKeys;

    styleOnlyAuto: boolean;

    constructor(options: IMultiselectOptions) {

        this.outputKey = options.outputKey;
        this.labelKey = options.labelKey;
        this.colorKeys = options.colorKeys;
        this.styleOnlyAuto = options?.styleOnlyAuto;

        if (options.styleFn) {
            this.styleFn = (option): string => options.styleFn(option);
        }

        if (options.classFn) {
            this.classFn = (option): string => options.classFn(option);
        }
    }

    //To override
    styleFn = (option: any): string => {
        return '';
    }

    classFn = (option: any): string => {
        return '';
    }
}

export interface IMultiselectSelection {

    label: string;

    value: string;

    getValue(): string | number;
}

export interface IMultiselectModel {

    selections: any[];

    value: string;

    label: string;
}


export class MultiselectSelection implements IMultiselectSelection { //TODO: guardare logica per badges

    label: string;

    value: string;

    constructor(selection: any) {
        this.label = selection.label;
        this.value = selection.value;
    }

    getValue() {
        return typeof this.value == 'object' ? this.label : this.value || this.label;
    }
}


export class MultiselectModel implements IMultiselectModel {

    selections: MultiselectSelection[];

    hasCounter: boolean;

    constructor(selections: MultiselectSelection[], hasCounter: boolean = false) {
        this.selections = selections || [];
        this.hasCounter = hasCounter;
    }

    get selectionsIds() {
        return this.selections.map((selection) => selection.getValue());
    }

    get value() {
        let count = this.selections.length;
        if (count > 2 && this.hasCounter) {
            return `${this.selections[0].getValue()}, ${this.selections[1].getValue()} (+${count - 2})`;
        } else {
            return this.selections.reduce((res, sel, index) => res += ((index ? '-' : '') + sel.getValue()), '');
        }
    }

    get label() {
        let count = this.selections.length;
        if (count > 2 && this.hasCounter) {
            return `${this.selections[0].label}, ${this.selections[1].label} (+${count - 2})`;
        } else {
            return this.selections.reduce((res, sel, index) => res += ((index ? ', ' : '') + sel.label), '');
        }
    }

    removeSelection(currentSelection) {
        const selectionIndex = this.selections.findIndex((selection) => currentSelection == selection.value);
        this.selections.splice(selectionIndex, 1);

    }

    addSelection(selection) {
        this.selections.push(new MultiselectSelection(selection));
    }

    reset() {
        this.selections = [];
    }

}